import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { effects, reducers } from './+state';

import { SearchFacade } from './service/search.facade';

@NgModule({
  providers: [
    SearchFacade,
    provideState('SearchState', reducers),
    provideEffects(effects)
  ]
})
export class SearchModule {}
